<template>
    <div class="none-data">
        {{title}}
    </div>
</template>

<script>
export default {
    name: 'NoneData',
    props: {
        title: {
            type: String,
            default: '데이터가 없습니다.',
        },
    },
}
</script>

<style scoped>
</style>